<template>
  <div>
    <transition-group name="list">
      <b-button
        v-for="(item, idx) in items"
        :key="item.id"
        v-b-toggle="collapsible ? `result-card${item.id}` : false"
        :class="cardStyle || 'my-3 pt-3 shadow rounded-lg bg-white border-0'"
        block
      >
        <div class="px-4">
          <component
            :is="componentMap[item.resultType.toUpperCase()]"
            :item="item"
            :name="name"
            :account-number="accountNumber"
            :phoneNumber="phoneNumber"
            :destination="destination"
            :bol="bol"
            @change-flag="(value) => { $emit('change-flag', idx, value, item.resultType); }"
            @update-item="(value) => { $emit('update-item'); }"
            @error-item="(value) => {  $emit('error-item', value); }"
          ></component>
        </div>
      </b-button>
    </transition-group>
  </div>
</template>

<script>
import SearchResultPickup from './SearchResultPickup.vue';
import SearchResultWarehouse from './SearchResultWarehouse.vue';
// import SearchResultShipment from './SearchResultShipment.vue';
import SearchResultManifest from './SearchResultManifest.vue';
import SearchResultDelivering from './SearchResultDelivering.vue';
import SearchResultComplete from './SearchResultComplete.vue';

export default {
  name: 'SearchResults',
  components: {
    SearchResultPickup,
    SearchResultWarehouse,
    SearchResultManifest,
    SearchResultDelivering,
    SearchResultComplete,
  },
  props: {
    cardStyle: {
      type: String,
    },
    items: {
      type: Array,
    },
    name: {
      type: String,
    },
    phoneNumber: {
      type: String,
    },
    destination: {
      type: String,
    },
    bol: {
      type: String,
    },
    accountNumber: {
      type: String,
    },
    collapsible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      componentMap: {
        PICKUP: 'SearchResultPickup',
        TOLOAD: 'SearchResultWarehouse',
        MANIFEST: 'SearchResultManifest',
        TODELIVER: 'SearchResultDelivering',
        COMPLETED: 'SearchResultComplete',
      },
    };
  },
  methods: {},
};
</script>

<style scoped>
.completed-order {
  background: #f0f5e9;
}

.list-enter-active,
.list-leave-active {
  transition: all 1s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}
</style>
